import React from "react";

// Helpers
import { getDomainITPL } from "utils/helpers";

function AssessmentResults({ finalInitialRecommendation, totalScore }) {
  return (
    <div className="bg-gray-100 rounded-lg mx-4 px-6 py-6 md:px-10 md:py-10 space-y-8 sm:space-y-10 text-center">
      <div>
        <p className="uppercase text-2xl sm:text-4xl xl:text-5xl font-bold">
          Submission Completed
        </p>
      </div>
      <div>
        <p className="text-base sm:text-xl xl:text-2xl font-bold">
          Here is your evaluation score:
        </p>
      </div>
      <div>
        <p className="text-5xl sm:text-7xl xl:text-9xl font-bold">
          {totalScore}
        </p>
      </div>
      <div className="bg-sky-300 rounded-lg px-8 py-6">
        <p className="text-justify text-sm sm:text-lg xl:text-2xl ">
          <b>Initial Recommendations:</b>
          <br />
          {finalInitialRecommendation}
        </p>
      </div>
      <div>
        <button
          className="uppercase tracking-widest bg-black text-white w-full p-2 rounded-xl text-lg xl:text-2xl font-semibold hover:opacity-60 transition-all duration-300"
          onClick={() => window.location.assign(getDomainITPL())}
        >
          Back to Home
        </button>
      </div>
    </div>
  );
}

export default AssessmentResults;
